import { observer } from 'mobx-react-lite'
import { AutoFollowUp, Box, DaysDropdown, Switch, Typography } from 'shared/ui'
import { LINK_SURVEYS_FOLLOW_UP_LEARN_MORE } from 'shared/constants/links'
import type { FallbackActionsStore } from './store/fallbackActionsStore'
import styles from './styles.module.scss'

type IFallbackActionsProps = {
  store: FallbackActionsStore
}

export const FallbackActions = observer(({ store }: IFallbackActionsProps) => {
  const {
    autoFollowUpEnabled,
    followUpWindow,
    followUpAssertiveness,
    sessionLifetime,
    setAutoFollowUpEnabled,
    setFollowUpWindow,
    setFollowUpAssertiveness,
    setSessionLifetime,
  } = store

  return (
    <>
      <Box display='flex'>
        <Box display='flex' flexDirection='column' flexGrow='1'>
          <Typography variant='body-lg-medium' ariaLabel='AutoFollowUp'>
            Auto FollowUp™
          </Typography>
          <Typography
            variant='body-md-regular'
            ariaLabel='AutoFollowUpDesc'
            color='var(--content-primary-secondary)'
            marginTop={4}
          >
            AI-powered follow-ups to maximize engagement.{' '}
            <a
              href={LINK_SURVEYS_FOLLOW_UP_LEARN_MORE}
              target='_blank'
              rel='noreferrer'
              className={styles.learnMoreLink}
            >
              Learn more
            </a>
          </Typography>
        </Box>
        <Box paddingTop='4px'>
          <Switch value={autoFollowUpEnabled} onChange={setAutoFollowUpEnabled} size='middle' />
        </Box>
      </Box>
      {autoFollowUpEnabled && (
        <AutoFollowUp
          followUpWindow={followUpWindow}
          followUpAssertiveness={followUpAssertiveness}
          setFollowUpWindow={setFollowUpWindow}
          setFollowUpAssertiveness={setFollowUpAssertiveness}
          assertivenessLabel='How frequently should the agent follow up?'
        />
      )}
      <Typography variant='body-lg-medium' ariaLabel='EndSession' marginTop={32}>
        End session
      </Typography>
      {autoFollowUpEnabled ? (
        <Typography
          variant='body-md-regular'
          ariaLabel='EndSessionDesc'
          color='var(--content-primary-secondary)'
          marginTop={4}
          tag='div'
        >
          If the contact doesn&apos;t reply within 1 day after the follow-up window
        </Typography>
      ) : (
        <DaysDropdown
          label="If the contact doesn't reply within"
          value={sessionLifetime}
          onChange={setSessionLifetime}
          days={Array(5)
            .fill(0)
            .map((_, index) => ({
              value: index + 1,
              label: String(index + 1),
            }))}
          className={styles.sessionLifetime}
        />
      )}
    </>
  )
})
